import { render, staticRenderFns } from "./indicases.vue?vue&type=template&id=7bf1ab5a&scoped=true"
import script from "./indicases.vue?vue&type=script&lang=js"
export * from "./indicases.vue?vue&type=script&lang=js"
import style0 from "./indicases.vue?vue&type=style&index=0&id=7bf1ab5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1ab5a",
  null
  
)

export default component.exports